import { recordPath, recordRoute } from '@/shared/registry'

/** The permission Find Lab Instances and Lab Instance Details need. */
export const readLabInstancesPermission = 'launch.lab-instances.read'

/** Notes, ending someone's lab and Monitor Labs. */
export const writeLabInstancesPermission = 'launch.lab-instances.write'

/** Exempting labs from the attempt limit, and taking the exemption away. */
export const exemptLabInstancesPermission = 'launch.lab-instances.attempt-exemptions.write'

/** The most labs one exemption takes, as the API allows. */
export const maxExemptions = 50

/** Where Find Lab Instances lives. */
export const labInstancesPath = '/launch/lab-instances'

/** Lab Instance Details' route. */
export const labInstanceRoute = recordRoute('launch', 'lab-instances')

export function labInstancePath(labInstanceId: string): string {
  return recordPath('launch', 'lab-instances', labInstanceId)
}

/** The API's lab instance search, and its export at `${labInstancesApi}/export`. */
export const labInstancesApi = '/launch/v1/lab-instances'

export function labInstanceApi(labInstanceId: string): string {
  return `${labInstancesApi}/${encodeURIComponent(labInstanceId)}`
}

/** Exempting the labs a request names from the attempt limit, or taking their exemption away. */
export function exemptionApi(action: 'exempt' | 'remove-exemption'): string {
  return `${labInstancesApi}/${action}`
}

/** A lab instance's notes, to add one, and ending someone's lab. */
export function labInstanceActionApi(labInstanceId: string, action: 'notes' | 'cancel'): string {
  return `${labInstanceApi(labInstanceId)}/${action}`
}

/** Find Lab Instances filtered to one class's instances, as Class Details links to it. */
export function classLabInstancesPath(classId: string): string {
  return `${labInstancesPath}?${new URLSearchParams({ filter: `classId:in:${classId}` }).toString()}`
}

/** Find Lab Instances filtered to one class's exam instances. */
export function classExamLabInstancesPath(classId: string): string {
  const query = new URLSearchParams([
    ['filter', `classId:in:${classId}`],
    ['filter', 'exam:in:true'],
  ])
  return `${labInstancesPath}?${query.toString()}`
}

/** Monitor Labs' route: a class's lab monitor, opened from Class Details. */
export const labMonitorRoute = '/launch/classes/:classId/lab-monitor'

export function labMonitorPath(classId: string): string {
  return `/launch/classes/${encodeURIComponent(classId)}/lab-monitor`
}

/** The API's class lab monitor: what it offers, and opening it. */
export function labMonitorApi(classId: string): string {
  return `/launch/v1/classes/${encodeURIComponent(classId)}/lab-monitor`
}
